import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock-small",
  "use": "icon-lock-small-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-lock-small\"><path d=\"M544 736c0 17.6-14.4 32-32 32s-32-14.4-32-32V608c0-17.6 14.4-32 32-32s32 14.4 32 32v128z\" /><path d=\"M832 384H192c-35.2 0-64 28.8-64 64v384h64V480c0-17.6 14.4-32 32-32h576c17.6 0 32 14.4 32 32v352h64V448c0-35.2-28.8-64-64-64z\" /><path d=\"M832 785.27V832c0 35.2-28.8 64-64 64H256c-35.2 0-64-28.8-64-64v-46.73c-38.185 22.216-64-0.397-64 46.73 0 70.4 57.6 128 128 128h512c70.4 0 128-57.6 128-128 0-47.128-25.814-24.516-64-46.73zM512 64c-140.8 0-256 115.2-256 256v128h64V320c0-105.6 86.4-192 192-192s192 86.4 192 192v128h64V320c0-140.8-115.2-256-256-256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/lock-small.svg
// module id = 0kAA
// module chunks = 65